/* eslint-disable
    guard-for-in,
    import-x/order,
    no-lonely-if,
    no-multi-assign,
    no-restricted-syntax,
    prefer-const,
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS201: Simplify complex destructure assignments
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import APIUtil from 'util/APIUtil';
import {SingletonCollection} from 'util/backbone-extensions';

import * as OnboardingActions from 'actions/OnboardingActions';
import {SequenceAlignmentServerResponse} from 'analyses/alignment/AlignmentActions';
import Digests from 'analyses/Digests';
import TranslationTabState from 'analyses/TranslationTabState';
import VirtualDigestTabState from 'analyses/VirtualDigestTabState';
import * as analytics from 'analytics/Analytics';
import asm from 'assembly/Asm';
import {assert} from 'Asserts';
import * as PermissionDAO from 'auth/PermissionDAO';
import {canRequestAccess, getArgForRequestAccess, requestAccess} from 'auth/RequestAccess';
import BasicFolderItem from 'basic-folder-item/BasicFolderItem';
import BenchlingConfig from 'BenchlingConfig';
import * as benchlingUtil from 'BenchlingUtil';
import * as biojs from 'BioJS';
import getConfig from 'getConfig';
import MoleculeFileState from 'chemistry/molecules/tabs/MoleculeFileState';
import {AlignmentAnalysis} from 'analyses/Analyses';
import Enzymes, {Enzyme} from 'molbio/enzymes/backbone/Enzymes';
import {Selection} from 'molbio/maps/selectables/Selection';
import * as sequencelib from 'components/Sequence';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import * as statusbar from 'components/StatusBar';
import SequenceAlignmentTabState from 'molbio/tabstates/SequenceAlignmentTabState';
import CircularMapTabState from 'molbio/tabstates/CircularMapTabState';
import MiniMapTabState from 'molbio/tabstates/MiniMapTabState';
import ProteinMapTabState from 'molbio/tabstates/ProteinMapTabState';
import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Strand} from 'constants/MolbioConstants';
import * as NavConstants from 'constants/NavConstants';
import {LocationSummary} from 'constants/SampleConstants';
import * as SequenceAnalysisConstants from 'constants/SequenceAnalysisConstants';
import {EnzymePreferences} from 'molbio/enzymes/EnzymeConstants';
import * as EnzymeUtil from 'molbio/enzymes/EnzymeUtil';
import {
  SEQUENCE_LINEAR_MAP_TAB_STATES,
  SEQUENCE_MINIMAP_TAB_STATES,
} from 'molbio/maps/SequenceMapBackboneConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
// @ts-expect-error
import FileBrowserStore from 'file-browser/FileBrowserStore';
import FinderUtil from 'file-browser/FinderUtil';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import {ProjectSettingsModal, ProjectSettingsModalProps} from 'file-browser/ProjectSettingsModal';
import {FilePreferences} from 'folder-items/FileConstants';
import Mixture from 'folder-items/Mixture';
import ProxyFile from 'folder-items/ProxyFile';
import FolderItemState, {FolderItemStateAttributes, FolderItemStateModel} from 'filestate/FolderItemState';
import AnalyticsDashboardFileState from 'insights/analytics-dashboards/backbone/AnalyticsDashboardFileState';
import {addEmbeddedDashboardTab} from 'insights/embeddings/backbone/InitializeBioentityEmbeddedDashboardTab';
import InventoryFileStore from 'inventory/InventoryFileStore';
import * as colors from 'lib/Colors';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import localStorage from 'LocalStorage';
import MetadataTabState from 'metadata/MetadataTabState';
import BulkAssemblyFileState from 'molbio/bulk-assembly/backbone/BulkAssemblyFileState';
import NucleotidesTabState from 'molbio/monomers/NucleotidesTabState';
import * as NucleotidesUIReduxActions from 'molbio/monomers/NucleotidesUIReduxActions';
import * as FeaturePanelUIReduxActions from 'toolbar/feature-panel/FeaturePanelUIReduxActions';
import {LegacyFolderURLQueryKey, parseFolderURL} from 'nav/sidepanel/listing/ParseURLs';
import {QueryKey} from 'nav/sidepanel/listing/SearchURLs';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import initializeCoreBioentityWorkspaceTabs from 'nav/workspace/initializeCoreBioentityWorkspaceTabs';
import {BufferState, TabState} from 'Navigation';
import {EntryProtocol} from 'notebook/ELNConstants';
import Entry from 'notebook/entries/backbone/filestate/Entry';
import BaseEntryProtocolTabState from 'notebook/entries/backbone/tabs/BaseEntryProtocolTab';
// @ts-expect-error
import * as EmptyEntryTab from 'notebook/entries/backbone/tabs/EmptyEntryTab';
import EntryProtocolTabState from 'notebook/entries/backbone/tabs/EntryProtocolTab';
import * as ExternalEntryProtocol from 'notebook/entries/backbone/tabs/ExternalEntryProtocol';
import * as NewEntryProtocolTab from 'notebook/entries/backbone/tabs/NewEntryProtocolTab';
import TemplateFile from 'notebook/entry-templates/backbone/filestate/TemplateFile';
import NoteTabState from 'notebook/notes/tabs/NoteTabState';
import Protocol from 'notebook/protocols/backbone/filestate/Protocol';
import ProtocolTabState from 'notebook/protocols/backbone/tabs/ProtocolTabState';
import ReviewTabState from 'notebook/reviews/ReviewTabState';
import * as ReviewUtil from 'notebook/reviews/ReviewUtil';
import notifications from 'notifications';
import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {
  FILE_STATE_INITIALLY_LOADED_EVENT,
  FILE_STATE_LOADING_EVENT,
} from 'performance/processNavigationEvents';
import preferences from 'Preferences';
import ProcessTaskFileState from 'processes/process-task-details/ProcessTaskFileState';
import ProcessFileState from 'processes/process-details/ProcessFileState';
import {ProteinBiochemicalPropertiesTabState} from 'molbio/proteins/BiochemicalPropertiesTab';
import AlphaFoldTabState from 'molbio/proteins/alphafold/AlphaFoldTabState';
import Protein from 'molbio/proteins/Protein';
import {getStore} from 'redux-stores/Store';
import RelevantItemsTabState from 'relevant-items/RelevantItemsTabState';
import RequestFileState from 'requests/request-view/RequestFileState';
import ResultStatusTabRenderer from 'results/validation/status-tab/ResultStatusTabRenderer';
import ResultStatusTabState from 'results/validation/status-tab/ResultStatusTabState';
import RunFileState from 'runs/editor/RunFileState';
import ContainerFileState from 'samples/containers/ContainerFileState';
import BoxFileState from 'samples/grids/BoxFileState';
import GridFileState from 'samples/grids/GridFileState';
import PlateFileState from 'samples/grids/PlateFileState';
import * as SampleSchemaActions from 'samples/SampleSchemaActions';
import * as StorableActions from 'samples/StorableActions';
import EntityTestOrdersTabState from 'sample-tests/ui/test-orders/EntityTestOrdersTabState';
import {SchemaValidationState} from 'schemas/SchemaValidationConstants';
import WorkspaceStore from 'sidebar/WorkspaceStore';
import EntityStore from 'stores/EntityStore';
import * as ToolbarConstants from 'toolbar/ToolbarConstants';
import {TOOLBARS} from 'toolbar/ToolbarConstants';
import licenses from 'user/Licenses';
import StageEntryFile from 'workflows/stage-entries/StageEntryFile';
import {Optional} from 'util/Types';

import FileState, {FileStateAttributes} from 'filestate/FileState';
import BenchlingAppFileState from 'benchling-apps/backbone/BenchlingAppFileState';
import {SequenceAnalysisSummary} from 'biojs/Sequence';
import runModal from 'ui-library/runModal';
import AnalysisFileState from 'analysis-tool/backbone/AnalysisFileState';
import ConnectionFileState from 'instruments/connections/connection-editor/ConnectionFileState';
import FormDefinitionFileState from 'forms/form-definition/FormDefinitionFileState';
import JellyfishFileState from 'app-core/archetype/workspace/JellyfishFileState';
import ProcedureFileState from 'procedures/ProceduresFileState';
import SubtemplateFile from 'notebook/entry-templates/backbone/filestate/SubtemplateFile';
import StudyFileState from 'studies/workspace/StudyFileState';
import {AssemblyHistoryQuery} from 'molbio/visual-history/assembly-history/__generated/AssemblyHistoryQuery';
import {createAssemblyHistoryTabState} from 'molbio/visual-history/assembly-history/AssemblyHistoryActions';
import WorksheetFileState from 'notebook/worksheets/workspace/WorksheetFileState';
import ComplexPolymerComponentsTabState from 'modbio/complex-polymers/tabs/ComplexPolymerComponentsTabState';
import ComplexPolymerMapTabState from 'modbio/complex-polymers/tabs/ComplexPolymerMapTabState';
import Store from 'lib/Store';
import LocationFileState from 'samples/locations/LocationFileState';
import DatasetFileState from 'data-frames/workspace/DatasetFileState';
import FileFileState from 'files/workspace/FileFileState';
import * as PoliceableActions from 'collaborator-components/PoliceableActions';
import {SavingCollaborationManagementModal} from 'collaborator-components/CollaborationManagementModal';
import * as SourceActions from 'file-browser/SourceActions';
import {Collaboration} from 'collaborator-components/useCollaborationManagementState';
import {isCollaboratableId} from 'auth/isCollaboratable';
import RequestV2SubmissionFileState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionFileState';
import {compact} from '@benchling/js-utils';
import RequestV2DefinitionFileState from 'processes/requests_v2/request-v2-definition/RequestV2DefinitionFileState';
import AnalysisTemplateFileState from 'analysis-tool/templates/AnalysisTemplateFileState';
import AntibodyMapTabState from 'antibodies/antibody-map/AntibodyMapTabState';

const {EmptyEntryTabState} = EmptyEntryTab;
const {NewEntryProtocolTabState} = NewEntryProtocolTab;
const {ExternalEntryProtocolTabState} = ExternalEntryProtocol;

export class BasicInformationPanelState extends Backbone.Model {}

// SEQUENCE
interface MergedMapStateSignatures {
  set({active}: {active: boolean}): void;
}

interface FeaturePanelStateAttrs {
  sidebarOpen: boolean;
  activeSubPanel: string;
}

export class FeaturePanelState extends Backbone.Model {
  defaults(): FeaturePanelStateAttrs {
    return {
      sidebarOpen: false,
      activeSubPanel: ToolbarConstants.SEQUENCE_FEATURE_PANEL_ANNOTATIONS,
    };
  }

  createAnnotation(sequenceID: string, selection: Selection): void {
    getStore().dispatch(FeaturePanelUIReduxActions.openCreateNewAnnotation(sequenceID));
    this.set({activeSubPanel: ToolbarConstants.SEQUENCE_FEATURE_PANEL_ANNOTATIONS});
  }

  createTranslation(sequenceID: string, strand?: Strand): void {
    getStore().dispatch(FeaturePanelUIReduxActions.openCreateNewTranslation(sequenceID, strand));
    this.set({activeSubPanel: ToolbarConstants.SEQUENCE_FEATURE_PANEL_TRANSLATIONS});
  }
}

interface EditVersionStateAttrs {
  version: sequencelib.SequenceVersion | null;
  cloneName: string;
  active: boolean;
}

export class EditVersionState extends Backbone.Model {
  defaults(): EditVersionStateAttrs {
    return {
      version: null,
      cloneName: '',
      active: false,
    };
  }
}

interface HistoryPanelStateAttrs {
  editState: EditVersionState;
}

export class HistoryPanelState extends Backbone.Model {
  defaults(): HistoryPanelStateAttrs {
    return {
      editState: new EditVersionState(),
    };
  }
}

export interface InProgressAlignmentAttrs {
  algorithm: string | null;
  created: Date;
  numSequences: number;
}

class InProgressAlignment extends Backbone.Model {
  defaults(): InProgressAlignmentAttrs {
    return {
      algorithm: null,
      created: new Date(),
      numSequences: 0,
    };
  }
}

interface AlignmentPanelStateAttrs {
  alignmentsInProgress: Backbone.Collection<InProgressAlignment>;
}

export class AlignmentPanelState extends Backbone.Model {
  defaults(): AlignmentPanelStateAttrs {
    return {
      alignmentsInProgress: new Backbone.Collection([], {model: InProgressAlignment}),
    };
  }

  /**
   * Wraps the given promise to show a pending alignment indicator in the alignment panel.
   *
   * Replaces the registerAlignmentXhr function below for ES Promises.
   * @param promise Promise to wrap.
   * @param properties Properties of the alignment for displaying in the panel.
   */
  async withAlignmentPending<T>(
    promise: Promise<T>,
    properties: Partial<InProgressAlignmentAttrs>
  ): Promise<T> {
    const progress = new InProgressAlignment(properties);
    const progressCollection = this.get('alignmentsInProgress');
    progressCollection.add(progress);
    try {
      return await promise;
    } finally {
      progressCollection.remove(progress);
    }
  }

  // Use withAlignmentPending above for ES Promises
  registerAlignmentXhr(
    xhr: JQueryPromise<SequenceAlignmentServerResponse | Array<SequenceAnalysisSummary>>,
    properties: Partial<InProgressAlignmentAttrs>
  ): void {
    const progress = new InProgressAlignment(properties);
    const progressCollection = this.get('alignmentsInProgress');
    progressCollection.add(progress);
    xhr.always(() => progressCollection.remove(progress));
  }
}

interface PrimerPanelStateAttrs {
  activeSubPanel: string;
  activePrimer: SequencePrimer | null;
  overhang: string;
  newPrimer: SequencePrimer | null;
  newPrimerLibraryId: number;
  meltingTemperature: string | null;
}

class PrimerPanelState extends Backbone.Model {
  defaults(): PrimerPanelStateAttrs {
    return {
      activeSubPanel: ToolbarConstants.SEQUENCE_PRIMER_PANEL_PRIMERS,
      activePrimer: null,
      overhang: '',
      newPrimer: null,
      newPrimerLibraryId: -1,
      meltingTemperature: null,
    };
  }
}

interface RestrictionPanelStateAttrs {
  activeSubPanel: string;
  selectedEnzymes: Enzymes;
  search: string;
  viewEnzymes: boolean;
  enzymeListId: number;
  enzymesProvider: string;
  highlightCompatible: boolean;
  cutRegion: string;
}

export class RestrictionPanelState extends Backbone.Model {
  defaults(): RestrictionPanelStateAttrs {
    return {
      activeSubPanel: ToolbarConstants.SEQUENCE_DIGEST_PANEL_NEW_DIGEST,
      selectedEnzymes: new Enzymes(),
      search: '',
      viewEnzymes: preferences.get(EnzymePreferences.VIEW_ENZYMES),
      enzymeListId: preferences.get(EnzymePreferences.ENZYME_LIST_ID),
      enzymesProvider: preferences.get(EnzymePreferences.PROVIDER),
      highlightCompatible: false,
      cutRegion: 'anywhere',
    };
  }

  initialize(): void {
    this.changeViewEnzyme = this.changeViewEnzyme.bind(this);
  }

  registerListeners(): void {
    $(window).bind(
      'storage',
      _.bind((e: unknown) => this.updateActiveEnzymes(e), this)
    );
    $(window).bind(
      'storage',
      _.bind(() => {
        this.updateHighlightCompatible();
      }, this)
    );
    this.listenTo(this.get('selectedEnzymes'), 'add remove reset', () => {
      this.setLocalStorage();
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.get('sequence').get('enzymes'), 'change:active', this.enzymeActiveChange);
    this.listenTo(
      this.get('sequence').get('enzymes'),
      'change:cutPositions change:active change:color',
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.changeViewEnzyme
    );
    this.on('change:highlightCompatible', () => {
      this.setHighlightCompatible();
    });
  }

  updateHighlightCompatible(): void {
    const highlightCompatible = preferences.get(FilePreferences.HIGHLIGHT_COMPATIBLE);
    this.set({highlightCompatible: highlightCompatible != null});
  }

  setHighlightCompatible(): void {
    if ((window.event != null ? window.event.type : undefined) !== 'storage') {
      if (this.get('highlightCompatible')) {
        preferences.set(FilePreferences.HIGHLIGHT_COMPATIBLE, true);
      } else {
        preferences.unset(FilePreferences.HIGHLIGHT_COMPATIBLE);
      }
    }
  }

  setLocalStorage(): void {
    if ((window.event != null ? window.event.type : undefined) !== 'storage') {
      Enzymes.setLocalStorageActives(this.get('selectedEnzymes'));
    }
  }

  enzymeActiveChange(enzyme: Enzyme, active: boolean, options: {trigger: boolean}): void {
    const trigger = options != null && _.has(options, 'trigger') ? options.trigger : true;

    if (active) {
      if (!enzyme.has('color')) {
        // this will stop coloring enzymes if you have more than 10 active enzymes
        let color;
        let colorToUse: string | null = null;
        for (const eid of Array.from(EnzymeUtil.getCompatibleEnzymeIds(enzyme.id))) {
          const otherEnzyme = this.get('sequence').get('enzymes').get(eid);
          colorToUse = otherEnzyme.color();
          if (colorToUse != null) {
            break;
          }
        }
        if (colorToUse == null) {
          const colorsUsed = this.get('selectedEnzymes').map((e: Enzyme) => e.color());
          for (color of Array.from(colors.shuffledPastelColors)) {
            if (colorsUsed.indexOf(color) === -1) {
              colorToUse = color;
              break;
            }
          }
        }
        // @ts-expect-error Backbone types don't recognize "trigger" param as a valid option.
        enzyme.set({color: colorToUse}, {trigger});
      }
      this.get('selectedEnzymes').add(enzyme);
    } else {
      enzyme.unset('color');
      this.get('selectedEnzymes').remove(enzyme);
    }
    this.changeViewEnzyme(enzyme, null, {trigger});
  }

  updateActiveEnzymes(e: unknown): Array<Enzyme> | void {
    const enzymeIds = localStorage.getItem('active-enzymes');
    const enzymes = this.get('sequence').get('enzymes');
    enzymes.each((enzyme: Enzyme) => enzyme.set({active: false, color: null}));
    if (enzymeIds != null) {
      const colorsHash = JSON.parse(enzymeIds);
      return (() => {
        const result = [];
        for (const id in colorsHash) {
          const color = colorsHash[id];
          const enzyme = enzymes.get(id);
          if (enzyme == null) {
            // If enzyme has been removed, silently skip over it
            continue;
          }
          result.push(enzyme.set({active: true, color}));
        }
        return result;
      })();
    }
  }

  // TODO: remove "value" arg, unused and always null.
  changeViewEnzyme(enzyme: Enzyme, value: null, options: {trigger: boolean}): void {
    const trigger = options != null && _.has(options, 'trigger') ? options.trigger : true;

    const viewEnzymes = this.get('viewEnzymes');
    if (enzyme.forceVisible()) {
      // @ts-expect-error - Trigger param is invalid and ignored by Backbone.
      enzyme.set('visible', true, {trigger});
      return;
    }

    if (!EnzymeUtil.doesEnzymeListContain(this.get('enzymeListId'), enzyme.id)) {
      // @ts-expect-error Backbone types don't recognize "trigger" param as a valid option.
      enzyme.set('visible', false, {trigger});
      return;
    }

    enzyme.updateVisibleByCuts(viewEnzymes);
  }
}

interface InformationPanelStateAttrs {
  activeSubPanel: string;
}

export class InformationPanelState extends Backbone.Model {
  defaults(): InformationPanelStateAttrs {
    return {
      activeSubPanel: ToolbarConstants.SEQUENCE_INFORMATION_PANEL_INFO,
    };
  }
}

export class GenomeEngineeringPanelState extends Backbone.Model {}

interface SequenceToolbarStateAttrs {
  featurePanelState: FeaturePanelState;
  restrictionPanelState: RestrictionPanelState;
  historyPanelState: HistoryPanelState;
  primerPanelState: PrimerPanelState;
  informationPanelState: InformationPanelState;
  alignmentPanelState: AlignmentPanelState;
  genomeEngineeringPanelState: GenomeEngineeringPanelState;
}

export class SequenceToolbarState extends Backbone.Model {
  defaults(): SequenceToolbarStateAttrs {
    return {
      featurePanelState: new FeaturePanelState(),
      restrictionPanelState: new RestrictionPanelState(),
      historyPanelState: new HistoryPanelState(),
      primerPanelState: new PrimerPanelState(),
      informationPanelState: new InformationPanelState(),
      alignmentPanelState: new AlignmentPanelState(),
      genomeEngineeringPanelState: new GenomeEngineeringPanelState(),
    };
  }
}

// PROTOCOL

export class ProtocolHistoryPanelState extends Backbone.Model {}

interface ProtocolToolbarStateAttrs {
  protocolHistoryPanelState: ProtocolHistoryPanelState;
  protocolInformationPanelState: BasicInformationPanelState;
}

class ProtocolToolbarState extends Backbone.Model {
  defaults(): ProtocolToolbarStateAttrs {
    return {
      protocolHistoryPanelState: new ProtocolHistoryPanelState(),
      protocolInformationPanelState: new BasicInformationPanelState(),
    };
  }
}

// PROTEIN

export class ProteinAnnotationsPanelState extends Backbone.Model {}

export class ProteinHistoryPanelState extends Backbone.Model {}

export class ProteinAlignmentPanelState extends Backbone.Model {}

interface ProteinToolbarStateAttrs {
  proteinAnnotationsPanelState: ProteinAnnotationsPanelState;
  proteinHistoryPanelState: ProteinHistoryPanelState;
  proteinInformationPanelState: BasicInformationPanelState;
  proteinAlignmentPanelState: ProteinAlignmentPanelState;
}

export class ProteinToolbarState extends Backbone.Model {
  defaults(): ProteinToolbarStateAttrs {
    return {
      proteinAnnotationsPanelState: new ProteinAnnotationsPanelState(),
      proteinHistoryPanelState: new ProteinHistoryPanelState(),
      proteinInformationPanelState: new BasicInformationPanelState(),
      proteinAlignmentPanelState: new ProteinAlignmentPanelState(),
    };
  }
}

// ENTRY
export class EntryHistoryPanelState extends Backbone.Model {}

interface EntryToolbarStateAttrs {
  entryInformationPanelState: BasicInformationPanelState;
  entryHistoryPanelState: EntryHistoryPanelState;
  panelShouldBeFullHeight: {
    'entry-history-panel': boolean;
    'entry-information-panel': boolean;
  };
}

export class EntryToolbarState extends Backbone.Model {
  defaults(): EntryToolbarStateAttrs {
    return {
      entryInformationPanelState: new BasicInformationPanelState(),
      entryHistoryPanelState: new EntryHistoryPanelState(),
      panelShouldBeFullHeight: {
        'entry-history-panel': true,
        'entry-information-panel': false,
      },
    };
  }
}

// SUBTEMPLATE
export class SubtemplateHistoryPanelState extends Backbone.Model {}

interface SubtemplateToolbarStateAttrs {
  subtemplateInformationPanelState: BasicInformationPanelState;
  subtemplateHistoryPanelState: SubtemplateHistoryPanelState;
  panelShouldBeFullHeight: {
    'subtemplate-history-panel': boolean;
    'subtemplate-information-panel': boolean;
  };
}

export class SubtemplateToolbarState extends Backbone.Model {
  defaults(): SubtemplateToolbarStateAttrs {
    return {
      subtemplateInformationPanelState: new BasicInformationPanelState(),
      subtemplateHistoryPanelState: new SubtemplateHistoryPanelState(),
      panelShouldBeFullHeight: {
        'subtemplate-history-panel': true,
        'subtemplate-information-panel': false,
      },
    };
  }
}

// TEMPLATE
export class TemplateHistoryPanelState extends Backbone.Model {}

interface TemplateToolbarStateAttrs {
  templateInformationPanelState: BasicInformationPanelState;
  templateHistoryPanelState: TemplateHistoryPanelState;
  panelShouldBeFullHeight: {
    'template-history-panel': boolean;
    'template-information-panel': boolean;
  };
}

export class TemplateToolbarState extends Backbone.Model {
  defaults(): TemplateToolbarStateAttrs {
    return {
      templateInformationPanelState: new BasicInformationPanelState(),
      templateHistoryPanelState: new TemplateHistoryPanelState(),
      panelShouldBeFullHeight: {
        'template-history-panel': true,
        'template-information-panel': false,
      },
    };
  }
}

// BASIC FOLDER ITEM

export class ComplexPolymerHistoryPanelState extends Backbone.Model {}
export class AntibodyHistoryPanelState extends Backbone.Model {}

interface BasicFolderItemToolbarStateAttrs {
  basicFolderItemInformationPanelState: BasicInformationPanelState;
  complexPolymerHistoryPanelState: ComplexPolymerHistoryPanelState;
  antibodyHistoryPanelState: AntibodyHistoryPanelState;
}

export class BasicFolderItemToolbarState extends Backbone.Model {
  defaults(): BasicFolderItemToolbarStateAttrs {
    return {
      basicFolderItemInformationPanelState: new BasicInformationPanelState(),
      complexPolymerHistoryPanelState: new ComplexPolymerHistoryPanelState(),
      antibodyHistoryPanelState: new AntibodyHistoryPanelState(),
    };
  }
}

// MIXTURE
interface MixtureToolbarStateAttrs {
  mixtureInformationPanelState: BasicInformationPanelState;
}

class MixtureToolbarState extends Backbone.Model {
  defaults(): MixtureToolbarStateAttrs {
    return {
      mixtureInformationPanelState: new BasicInformationPanelState(),
    };
  }
}

// STAGE ENTRY
export class StageEntryHistoryPanelState extends Backbone.Model {}

interface StageEntryToolbarStateAttrs {
  stageEntryInformationPanelState: BasicInformationPanelState;
  stageEntryHistoryPanelState: StageEntryHistoryPanelState;
}

class StageEntryToolbarState extends Backbone.Model {
  defaults(): StageEntryToolbarStateAttrs {
    return {
      stageEntryInformationPanelState: new BasicInformationPanelState(),
      stageEntryHistoryPanelState: new StageEntryHistoryPanelState(),
    };
  }
}

function trackFileUse(
  eventPrefix: string,
  fileId: string,
  fileState: FileState,
  source: Optional<string>,
  analyticsMetadata: {[key: string]: string | boolean | null}
): void {
  if (source == null) {
    return;
  }
  const fileType = APIUtil.apiIdToType(fileId);
  const eventName = `${eventPrefix}_${fileType}`;
  const isModifiedOligo =
    fileType === ModelTypeConstants.SEQUENCE &&
    (fileState as SequenceFileState).model().modifiedNucleotides().length > 0;
  const metadata: {[k: string]: string | boolean | null} = {
    ...analyticsMetadata,
    is_modified_oligo: isModifiedOligo,
    source,
  };
  metadata[`${fileType}_api_id`] = fileId;
  analytics.track('editor', eventName, metadata);
}

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export interface ProxyFileState<M extends ProxyFile<Record<string, any>, Store>> extends FolderItemState {
  model(): M;
}

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export class ProxyFileState<M extends ProxyFile<Record<string, any>, Store>> extends FolderItemState {
  hasUnsavedChanges(): boolean {
    // TODO: this is equivalent to `this.model().isUnsaved()`, should use that instead
    return this.model().get('savedVersion') !== this.model().get('openVersion');
  }

  handleModelChanges(): void {
    // Keep name and tagSchema in sync
    const model = this.model();
    this.set({name: model.name()});
    this.listenTo(model, `change:${model.proxiedField}`, () =>
      this.set({
        name: model.name(),
        tagSchema: model.tagSchema(),
      })
    );
  }

  initialize(attributes: FolderItemStateAttributes, options: unknown): void {
    super.initialize(attributes, options);
    this.listenTo(this.model(), `change:${this.model().proxiedField} change:isLatest change:dirty`, () => {
      this.model().setBanner();
    });
  }

  registerTitleAndURLSync(): void {
    this.on('change:name', () => {
      this.syncTitleAndURL();
    });
    this.listenTo(this.model(), `change:${this.model().proxiedField}`, () => {
      this.syncTitleAndURL();
    });
  }

  open(param?: {open?: boolean; versionId?: number}): JQueryPromise<FileState> {
    if (param == null) {
      param = {};
    }
    let {open, versionId} = param;
    if (open == null) {
      open = true;
    }
    // If the caller is trying to open a version of the file that is different from the
    // one currently loaded, we do a fetch instead of the default behavior of returning
    // a resolved promise.
    if (open && versionId != null && versionId !== this.model().openVersionId()) {
      return this.model()
        .fetch({versionId})
        .then(() => {
          FileStates.get().activate(this);
          return this;
        });
    }
    return super.open(...arguments);
  }
}

// Define a simple type for previously active protocol tab
interface ActiveProtocolTab {
  cid: string | undefined;
  title: string | undefined;
}

class FileStateWithEntryVersion extends ProxyFileState<Entry> {
  _reduxUnsubscribe!: (() => void) | null;

  static initClass(): void {
    this.prototype.hasNote = false;
    // manually added in initialize
  }

  _protocolTabState(
    protocol: EntryProtocol
  ): EntryProtocolTabState | ExternalEntryProtocol.ExternalEntryProtocolTabState {
    const attrs = {file: this.model(), protocolCid: protocol.cid};
    if (protocol.externalFile) {
      return new ExternalEntryProtocolTabState(attrs);
    }
    return new EntryProtocolTabState(attrs);
  }

  handleLeftBufferLock(): void {
    const allowEdits = this.model().allowEdits();
    this.buffers()
      .at(0)
      .tabs()
      .each((tab) => {
        if (tab instanceof BaseEntryProtocolTabState) {
          tab.set({closeable: allowEdits, draggable: allowEdits});
        }
      });
  }

  handleSplitWorkspaceChange(): void {
    const isWorkspaceSplitByUser = this.get('statusbar').get('splitWorkspace');
    if (!isWorkspaceSplitByUser) {
      const tab = this.buffers().getTabByClass(NoteTabState);
      if (tab != null) {
        tab.set({active: true});
      }
    }
  }

  shouldAddReviewTab(): boolean {
    if (this.findTab(ReviewTabState) != null) {
      return false;
    }
    if (ReviewUtil.hasReviewsEnabled(this.fileType())) {
      return true;
    }
    return this.model().proxied().review != null;
  }

  initialize(attributes: FolderItemStateAttributes, options: unknown): void {
    super.initialize(attributes, options);

    const proxyFile = this.model();
    const entryProtocols = proxyFile.entryProtocols();

    if (this.shouldConsiderAddingResultStatusTab()) {
      this._reduxUnsubscribe = new ResultStatusTabRenderer({
        entryFile: proxyFile,
        addResultStatusTab: () => {
          this.addResultStatusTab();
        },
      }).init();
    }

    // Create initial left-buffer tabs
    for (const protocol of Array.from(entryProtocols)) {
      const tab = this._protocolTabState(protocol);
      tab.set({title: protocol.name});
      this.buffers().addTab(tab, {side: 'left'});
    }

    if (BenchlingConfig.ENABLE_PROTOCOLS_IN_ENTRIES) {
      if (proxyFile.allowEdits()) {
        this.buffers().addTab(new NewEntryProtocolTabState({file: proxyFile}), {side: 'left'});
      } else {
        this.buffers().addTab(new EmptyEntryTabState(), {side: 'left'});
      }
    }

    if (this.shouldAddReviewTab()) {
      this.addReviewTab();
    }
    __guard__(this.buffers().at(0).tabs().at(0), (x) => x.set({active: true}));

    // Create initial right-buffer tabs
    let noteTab = new NoteTabState({model: proxyFile});
    this.buffers().at(1).add(noteTab);

    noteTab.set({active: true});
    if (this.metadataTab != null) {
      this.buffers().at(1).add(this.metadataTab);
    }
    this.addRelevantItemTab();
    this.addTestOrdersTab();

    const defaultSplit = this.shouldAddReviewTab() && this.model().proxied().review != null;
    const splitPref = preferences.get(this.getSplitWorkspacePreferenceKey());
    this.setIsWorkspaceSplit(splitPref != null ? splitPref : defaultSplit);

    // AddTabIcon: visible if at least one protocol and entry is writable,
    // and activates new protocol tabstate on click.
    this.listenTo(this.buffers().at(0).tabs(), 'add remove reset', () => {
      this.handleLeftBufferLock();
    });
    this.listenTo(proxyFile, 'change', () => {
      this.handleLeftBufferLock();
    });
    this.handleLeftBufferLock();

    // Keeps the store's entryProtocol array in sync with the tab ordering.
    this.listenTo(this.buffers().at(0), 'reorderTabs', () => {
      const cids = this.buffers()
        .at(0)
        .tabs()
        .chain()
        .filter((tab: TabState) => tab instanceof BaseEntryProtocolTabState)
        .map((tab: BaseEntryProtocolTabState) => tab.get('protocolCid'))
        .value();
      if (this.model().allowEdits()) {
        this.model().reorderProtocols(cids);
      }
    });

    // Keep the tabs in sync with the store's entryProtocol array.
    this.listenTo(proxyFile, `change:${this.model().proxiedField} change:isLatest`, () => {
      this.updateOnModelChange();
    });
  }

  shouldConsiderAddingResultStatusTab(): boolean {
    return (
      this.findTab(ResultStatusTabState) == null &&
      this.hasResults() &&
      this.fileType() !== ModelTypeConstants.TEMPLATE // don't show in templates
    );
  }

  addResultStatusTab(): void {
    if (this.findTab(ResultStatusTabState) == null) {
      const resultStatusTab = new ResultStatusTabState({model: this.model()});
      this.buffers().addTab(resultStatusTab, {side: 'left', active: false});
    }
  }

  updateOnModelChange(): void {
    const proxyFile = this.model();
    // Collect current tabs in left-hand buffer.
    const leftTabs = this.buffers().at(0).tabs();

    // The "Add Protocol" tab will always render on the left buffer, not the right
    const oldAddProtocolTab = leftTabs.find(
      (t) => t instanceof NewEntryProtocolTabState || t instanceof EmptyEntryTabState
    );
    let newAddProtocolTab = null;

    if (BenchlingConfig.ENABLE_PROTOCOLS_IN_ENTRIES) {
      // Ensure there is an "Add Protocol" tab when edits are allowed, reusing the existing one if available
      if (proxyFile.allowEdits()) {
        newAddProtocolTab =
          oldAddProtocolTab instanceof NewEntryProtocolTabState
            ? oldAddProtocolTab
            : new NewEntryProtocolTabState({file: proxyFile});
      } else {
        // If edits are not allowed, and the entry has no protocols, use an 'empty entry' tab instead.
        if (proxyFile.entryProtocols().length === 0) {
          newAddProtocolTab =
            oldAddProtocolTab instanceof EmptyEntryTabState ? oldAddProtocolTab : new EmptyEntryTabState();
        } else {
          // If there are existing protocols and edits are not allowed, no "Add Protocol" or "Empty Entry" tab is needed.
          newAddProtocolTab = null;
        }
      }
    }

    // Preserve order for non-protocol tabs
    const nonProtocolTabs = compact([
      newAddProtocolTab,
      leftTabs.find((t) => t instanceof NoteTabState),
      leftTabs.find((t) => t instanceof MetadataTabState),
      leftTabs.find((t) => t instanceof RelevantItemsTabState),
      leftTabs.find((t) => t instanceof ReviewTabState),
      leftTabs.find((t) => t instanceof EntityTestOrdersTabState),
      leftTabs.find((t) => t instanceof ResultStatusTabState),
    ]);

    // Map existing protocol tabs by Protocol CID
    const oldProtocolTabs = leftTabs.filter((tab) => tab instanceof BaseEntryProtocolTabState);
    const protocolTabMap = _.indexBy(oldProtocolTabs, (tab) => tab.get('protocolCid'));

    // Track the previously active protocol tab by cid or title
    let previouslyActiveProtocolTab: ActiveProtocolTab | null = null;
    const activeOldTab = oldProtocolTabs.find((tab) => tab.get('active'));
    if (activeOldTab) {
      const activeTabCid = activeOldTab.get('protocolCid');
      const activeTabTitle = activeOldTab.get('title');
      previouslyActiveProtocolTab = {cid: activeTabCid, title: activeTabTitle}; // Save reference
    }

    // Determine new ordering of tabs
    let newestTab = newAddProtocolTab;

    // Collect new protocol tabs in a temporary array to validate changes
    const newProtocolTabs: Array<TabState> = [];

    // Process protocol tabs, updating titles of tabs.
    for (const ep of Array.from(proxyFile.entryProtocols())) {
      // note: if that cid is in protocolTabMap, we map it to tab, but we will get new CIDs here
      // eslint-disable-next-line benchlint/no-in-operator
      if (!(ep.cid in protocolTabMap)) {
        protocolTabMap[ep.cid] = newestTab = this._protocolTabState(ep);
      }
      protocolTabMap[ep.cid].set({title: ep.name});
      newProtocolTabs.push(protocolTabMap[ep.cid]);
    }

    // Combine temporary newProtocolTabs with the add protocol tab for change detection
    const checkNewProtocolTabOrder = [...newProtocolTabs, ...(newAddProtocolTab ? [newAddProtocolTab] : [])];
    // Include the 'add protocol tab' at the end when deciding if we need to reset the tabs.
    if (oldAddProtocolTab != null) {
      oldProtocolTabs.push(oldAddProtocolTab);
    }
    // If there was no change in the order of protocols, we can just quit now.
    if (_.all(_.zip(checkNewProtocolTabOrder, oldProtocolTabs), ([newTab, oldTab]) => newTab === oldTab)) {
      return;
    }

    // Otherwise, we update the tabs in the left buffer.
    // Note: in the un-split view, the position of the noteTab can be anywhere,
    // so we don't use it for comparing checkNewProtocolTabOrder vs oldProtocolTabs.
    const newTabs: Array<TabState> = [...nonProtocolTabs];

    // When reviews tab is missing but reviews is enabled make sure it gets added
    if (this.shouldAddReviewTab()) {
      this.addReviewTab();
    }

    // Append protocol tabs last
    newTabs.push(...newProtocolTabs);

    // Activate the newest protocol tab if no tab is active
    let activateTab = newAddProtocolTab?.get('active') || !_.any(newTabs, (tab) => tab.get('active'));

    // Reset tabs before setting any active tabs.
    leftTabs.reset(newTabs);

    // Checks if there was an active protocol tab if no note tab is active
    if (activateTab && previouslyActiveProtocolTab) {
      const matchingTab =
        newProtocolTabs.find((tab) => tab.get('protocolCid') === previouslyActiveProtocolTab?.cid) ||
        newProtocolTabs.find((tab) => tab.get('title') === previouslyActiveProtocolTab?.title);
      // If protocol tabs with duplicate titles exist, activates the first matching tab
      if (matchingTab) {
        matchingTab.set({active: true});
        activateTab = false; // Prevent activating a different tab
      }
    }

    // Activate the newest protocol tab
    if (activateTab && newestTab != null) {
      newestTab.set({active: true});
    }
  }

  addReviewTab(): void {
    if (!licenses.hasLicense('LICENSE_REVIEWS')) {
      return;
    }
    const reviewTab = new ReviewTabState({model: this.model()});
    this.buffers().addTab(reviewTab, {side: 'left'});
  }

  cleanUp(): void {
    super.cleanUp();
    if (this._reduxUnsubscribe) {
      this._reduxUnsubscribe();
    }
  }
}

FileStateWithEntryVersion.initClass();

export class EntryFileState extends FileStateWithEntryVersion {
  static Model: typeof Entry;

  static initClass(): void {
    this.fileType = ModelTypeConstants.ENTRY;
    this.Model = Entry;
  }

  open(param?: {open?: boolean; versionId?: number}): JQueryPromise<FileState> {
    if (param == null) {
      param = {};
    }
    let {open, versionId} = param;
    if (open == null) {
      open = true;
    }

    // If versionId is passed in we don't need to fetch the latest version of the file
    if (open && !versionId && this.model().isStale()) {
      return this.model()
        .fetch()
        .then(() => {
          FileStates.get().activate(this);
          return this;
        });
    }
    return super.open(...arguments);
  }

  defaults(): FileStateAttributes & {entry: Entry | null} {
    return {
      ...super.defaults(),
      statusbar: new statusbar.EntryStatusBarState(),
      toolbar: new EntryToolbarState(),
      entry: null,
    };
  }
}

EntryFileState.initClass();

class StageEntryFileState extends FileStateWithEntryVersion {
  static initClass(): void {
    this.fileType = ModelTypeConstants.STAGE_ENTRY;
    this.Model = StageEntryFile;
  }

  hasMetadata(): boolean {
    return BenchlingConfig.ENABLE_ENTRY_SCHEMAS;
  }

  isFolderItem(): false {
    return false;
  }

  defaults(): FileStateAttributes & {template: StageEntryFile | unknown} {
    return {
      ...super.defaults(),
      statusbar: new statusbar.StatusBarState(),
      toolbar: new StageEntryToolbarState(),
      template: null,
    };
  }
}

StageEntryFileState.initClass();

class TemplateFileState extends FileStateWithEntryVersion {
  static initClass(): void {
    this.fileType = ModelTypeConstants.TEMPLATE;
    this.Model = TemplateFile;
  }

  hasMetadata(): boolean {
    return BenchlingConfig.ENABLE_ENTRY_SCHEMAS;
  }

  isFolderItem(): false {
    return false;
  }

  defaults(): FileStateAttributes & {template: TemplateFile | null} {
    return {
      ...super.defaults(),
      statusbar: new statusbar.TemplateStatusBarState(),
      toolbar: new TemplateToolbarState(),
      template: null,
    };
  }
}

TemplateFileState.initClass();

export class SubtemplateFileState extends ProxyFileState<SubtemplateFile> {
  static initClass(): void {
    this.fileType = ModelTypeConstants.SUBTEMPLATE;
    this.Model = SubtemplateFile;
    // Attach note tab duringing initialization
    this.prototype.hasNote = false;
  }

  hasMetadata(): boolean {
    return false;
  }

  isFolderItem(): false {
    return false;
  }

  defaults(): FileStateAttributes & {subtemplate: SubtemplateFile | null} {
    return {
      ...super.defaults(),
      statusbar: new statusbar.SubtemplateStatusBarState(),
      toolbar: new SubtemplateToolbarState(),
      subtemplate: null,
    };
  }

  initialize(attributes: {}, options: unknown): void {
    super.initialize(attributes, options);

    // Directly initializing the Note tab since hasNote is intended for notes used as descriptions
    let noteTab = new NoteTabState({model: this.model()});
    this.buffers().at(0).add(noteTab);
    noteTab.set({active: true});
    // Apply split workspace preference
    const splitPref = preferences.get(this.getSplitWorkspacePreferenceKey());
    this.setIsWorkspaceSplit(splitPref != null ? splitPref : false);
  }
}

SubtemplateFileState.initClass();

export class BasicFolderItemFileState extends FolderItemState {
  static initClass(): void {
    this.fileType = ModelTypeConstants.BASIC_FOLDER_ITEM;
    this.Model = BasicFolderItem;
  }

  hasMetadata(): true {
    // Override BenchlingConfig.ENABLE_REGISTRY so BFI share links are usable
    return true;
  }

  defaults(): FileStateAttributes {
    return {
      ...super.defaults(),
      toolbar: new BasicFolderItemToolbarState(),
      statusbar: new statusbar.BasicFolderItemStatusBarState(),
    };
  }

  initialize(attributes: FolderItemStateAttributes, options: unknown): void {
    super.initialize(attributes, options);
    initializeCoreBioentityWorkspaceTabs(
      this.buffers(),
      this.metadataTab,
      this.entityMapTab,
      this.noteTab,
      this.resultsTab,
      this.storageTab,
      this.childEntityTabs,
      this.embeddedDashboardTab,
      this.relevantItemsTab,
      this.testOrdersTab
    );

    if (
      BenchlingConfig.MODBIO_ENABLE_COMPOSITE_ENTITIES &&
      attributes.complexPolymerData?.complexPolymerSchemaConfiguration != null
    ) {
      const polymerMapTab = new ComplexPolymerMapTabState({
        complexPolymerId: this.model().id,
        isEditable: this.model().permissions().writable,
      });
      this.buffers().at(0).add(polymerMapTab);

      const complexPolymerComponentsTab = new ComplexPolymerComponentsTabState({
        complexPolymerId: this.model().id,
        isEditable: this.model().permissions().writable,
      });
      this.buffers().at(1).add(complexPolymerComponentsTab);
    }

    if (BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_ENTITIES && attributes.antibodyData?.isAntibody) {
      const antibodyMapTab = new AntibodyMapTabState({
        antibodyId: this.model().id,
        isEditable: this.model().permissions().writable,
      });
      this.buffers().at(0).add(antibodyMapTab);
    }

    // Apply split workspace preference
    const splitPref = preferences.get(this.getSplitWorkspacePreferenceKey());
    this.setIsWorkspaceSplit(splitPref != null ? splitPref : true);
  }

  isRegistryItem(): true {
    return true;
  }
}

BasicFolderItemFileState.initClass();

export class MixtureFileState extends FolderItemState {
  static Model: typeof Mixture;

  static initClass(): void {
    this.fileType = ModelTypeConstants.MIXTURE;
    this.Model = Mixture;
  }

  hasMetadata(): true {
    // Override BenchlingConfig.ENABLE_REGISTRY so BFI share links are usable
    return true;
  }

  defaults(): FileStateAttributes {
    return {
      ...super.defaults(),
      toolbar: new MixtureToolbarState(),
      statusbar: new statusbar.MixtureStatusBarState(),
    };
  }

  initialize(attributes: FolderItemStateAttributes, options: unknown): void {
    super.initialize(attributes, options);
    initializeCoreBioentityWorkspaceTabs(
      this.buffers(),
      this.metadataTab,
      this.entityMapTab,
      this.noteTab,
      this.resultsTab,
      this.storageTab,
      this.childEntityTabs,
      this.embeddedDashboardTab,
      this.relevantItemsTab,
      this.testOrdersTab
    );
    // Apply split workspace preference
    const splitPref = preferences.get(this.getSplitWorkspacePreferenceKey());
    this.setIsWorkspaceSplit(splitPref != null ? splitPref : true);
  }

  isRegistryItem(): true {
    return true;
  }
}

MixtureFileState.initClass();

export class ProtocolFileState extends ProxyFileState<Protocol> {
  static initClass(): void {
    this.fileType = ModelTypeConstants.PROTOCOL;
    this.Model = Protocol;
    this.prototype.hasNote = false;
  }

  defaults(): FileStateAttributes {
    return {
      ...super.defaults(),
      statusbar: new statusbar.ProtocolStatusBarState(),
      toolbar: new ProtocolToolbarState(),
    };
  }

  initialize(attributes: FolderItemStateAttributes, options: unknown): void {
    super.initialize(attributes, options);
    const protocolTab = new ProtocolTabState({protocol: this.model()});
    this.buffers().at(0).add(protocolTab);
    protocolTab.set({active: true});
    if (this.metadataTab != null) {
      this.buffers().at(1).add(this.metadataTab);
      this.metadataTab.set({active: true});
    }
    this.addRelevantItemTab();
  }
}

ProtocolFileState.initClass();

export class ProteinFileState extends ProxyFileState<Protein> {
  static initClass(): void {
    this.fileType = ModelTypeConstants.PROTEIN;
    this.Model = Protein;
    this.prototype.hasNote = true;
  }

  defaults(): FileStateAttributes {
    return _.extend(super.defaults(), {
      toolbar: new ProteinToolbarState(),
    });
  }

  initialize(attributes: FolderItemStateAttributes, options: unknown): void {
    super.initialize(attributes, options);

    this.setupTabs(attributes.assemblyHistoryData);

    const splitPref = preferences.get(this.getSplitWorkspacePreferenceKey());
    this.setIsWorkspaceSplit(splitPref != null ? splitPref : true);
  }

  setupTabs(assemblyHistoryData?: AssemblyHistoryQuery | null): void {
    this._setupPrimaryBufferTab();
    this._setupSecondaryBufferTabs(assemblyHistoryData);
  }

  _setupPrimaryBufferTab(): void {
    const proteinMapTab = new ProteinMapTabState({protein: this.model()});
    this.buffers().at(0).add(proteinMapTab);
    proteinMapTab.set({active: true});
  }

  _setupSecondaryBufferTabs(assemblyHistoryData?: AssemblyHistoryQuery | null): void {
    const biochemicalPropertiesTab = new ProteinBiochemicalPropertiesTabState({
      polymer: this.model(),
    });
    this.buffers().at(1).add(biochemicalPropertiesTab);
    if (BenchlingConfig.MOLBIO_ENABLE_ALPHAFOLD_GA) {
      this.buffers().addTab(new AlphaFoldTabState({polymer: this.model()}), {side: 'right'});
    }
    this.buffers().at(1).add(this.noteTab);
    if (this.metadataTab != null) {
      this.buffers().at(1).add(this.metadataTab);
    }
    if (this.entityMapTab != null) {
      this.buffers().at(1).add(this.entityMapTab);
    }
    this.addRelevantItemTab();
    if (this.resultsTab != null) {
      this.buffers().at(1).add(this.resultsTab);
    }
    if (this.storageTab != null) {
      this.buffers().at(1).add(this.storageTab);
    }
    const assemblyHistoryTabState = createAssemblyHistoryTabState(this.model(), assemblyHistoryData);
    if (assemblyHistoryTabState != null) {
      this.buffers().at(1).add(assemblyHistoryTabState);
    }

    this.addChildEntityTabs();
    addEmbeddedDashboardTab(this.buffers(), this.embeddedDashboardTab);
    biochemicalPropertiesTab.set({active: true});
  }

  schemaValidationState(): SchemaValidationState | null {
    // overrides FolderItemState.schemaValidationState()
    return this.model().get('protein').schemaValidationState;
  }

  isRegistryItem(): true {
    return true;
  }
}

ProteinFileState.initClass();

type LongSequenceSubtype = ModelTypeConstants.SEQUENCE | ModelTypeConstants.RNA_SEQUENCE;

type SequenceToolbarPanelName = (typeof TOOLBARS)[ModelTypeConstants.SEQUENCE][number];

interface SequenceFileStateAttributes {
  sequence: sequencelib.Sequence;
  toolbar: SequenceToolbarState;
  topologyMap?: MiniMapTabState | CircularMapTabState;
  miniMap?: MiniMapTabState;
}

export interface SequenceFileState extends FolderItemState {
  model(): sequencelib.Sequence;

  get<K extends keyof SequenceFileStateAttributes>(key: K): SequenceFileStateAttributes[K];
}

export class SequenceFileState extends FolderItemState {
  static Model: typeof sequencelib.Sequence;

  static initClass(): void {
    this.fileType = ModelTypeConstants.SEQUENCE;
    this.Model = sequencelib.Sequence;
  }

  defaults(): FileStateAttributes & {sequence: sequencelib.Sequence | null; topologyMap: TabState | null} {
    return _.extend(super.defaults(), {
      sequence: null,
      topologyMap: null,
    });
  }

  cleanUp(): void {
    super.cleanUp();
    const sequence = this.get('sequence');
    if (sequence.supportsChemicalMods()) {
      getStore().dispatch(NucleotidesUIReduxActions.closeSequence(sequence.get('id')));
    }
    if (!sequence.isOligo()) {
      getStore().dispatch(FeaturePanelUIReduxActions.closeSequence(sequence.get('id')));
    }
  }

  initialize(attributes: FolderItemStateAttributes, options: unknown): void {
    super.initialize(attributes, options);
    const sequence = this.get('sequence');
    const raw = sequence.get('_sequence');

    this._bindRawChangesListener(raw);

    this._setupToolbar();
    this.setupTabs(attributes.assemblyHistoryData);

    const splitPref = preferences.get(this.getSplitWorkspacePreferenceKey());
    this.setIsWorkspaceSplit(splitPref != null ? splitPref : true);
    if (BenchlingConfig.ENABLE_NUE_MODULES || BenchlingConfig.ENABLE_GETTING_STARTED_FLOW) {
      OnboardingActions.fetchOnboardingTasks();
    }
  }

  _bindRawChangesListener(raw: biojs.Sequence): void {
    this.set({name: raw.get('name')});
    this.listenTo(raw, 'change:name', () => this.set({name: raw.get('name')}));

    this.set({tagSchema: raw.get('tagSchema')});
    this.listenTo(raw, 'change:tagSchema', () => this.set({tagSchema: raw.get('tagSchema')}));
  }

  _setupToolbar(): void {
    const sequence = this.get('sequence');

    this.set('toolbar', new SequenceToolbarState());

    const panelNames = TOOLBARS[sequence.subtype()];
    for (const panelName of panelNames) {
      if (this._PANEL_SETUP_FNS().hasOwnProperty(panelName)) {
        this._PANEL_SETUP_FNS()[panelName]();
      }
    }
  }

  _setupPrimaryBufferTab(): void {
    const sequence = this.get('sequence');

    const LinearMapTabState = SEQUENCE_LINEAR_MAP_TAB_STATES[sequence.subtype()];
    const linearMapTab = new LinearMapTabState({
      sequence,
      buffers: this.buffers(),
    });

    this.buffers().at(0).add(linearMapTab);
    linearMapTab.set({active: true});
  }

  _setupSecondaryBufferTabs(assemblyHistoryData?: AssemblyHistoryQuery | null): void {
    const sequence = this.get('sequence');
    const raw = sequence.get('_sequence');

    let miniMapTab;
    if (!sequence.isOligo()) {
      miniMapTab = new SEQUENCE_MINIMAP_TAB_STATES[sequence.subtype() as LongSequenceSubtype]({sequence});
      this.set({miniMap: miniMapTab});
    }

    let circularMapTab;
    if (raw.get('circular')) {
      circularMapTab = new CircularMapTabState({sequence});
      this.set({topologyMap: circularMapTab});
    } else if (!sequence.isOligo()) {
      this.set({topologyMap: miniMapTab});
    }

    let nucleotidesTabState;
    if (sequence.supportsChemicalMods()) {
      getStore().dispatch(NucleotidesUIReduxActions.openSequence(sequence.get('id')));
      nucleotidesTabState = new NucleotidesTabState({
        sequence,
        buffers: this.buffers(),
      });
    }

    const assemblyHistoryTabState = createAssemblyHistoryTabState(sequence, assemblyHistoryData);

    const secondTabs = [
      miniMapTab,
      circularMapTab,
      this.noteTab,
      this.metadataTab,
      this.entityMapTab,
      this.relevantItemsTab,
      this.testOrdersTab,
      this.resultsTab,
      this.storageTab,
      nucleotidesTabState,
      assemblyHistoryTabState,
    ].filter((tab) => tab != null) as Array<TabState>;

    this.buffers().at(1).add(secondTabs);
    this.addChildEntityTabs();
    addEmbeddedDashboardTab(this.buffers(), this.embeddedDashboardTab);

    if (this.get('topologyMap')) {
      const topologyMap: MergedMapStateSignatures = this.get('topologyMap')!;
      topologyMap.set({active: true});
    } else {
      this.noteTab.set({active: true});
    }

    // Attach any necessary assembly tabs.
    asm.of(raw).attachTabs(sequence, this.buffers().at(1));

    this._registerTopologyListener();
  }

  _setupFeaturePanel(): void {
    this.get('toolbar').get('featurePanelState').set({buffers: this.buffers()});
  }

  _setupRestrictionPanel(): void {
    this.get('toolbar').get('restrictionPanelState').set('buffers', this.buffers());

    this.get('sequence').listenToRestrictionPanelState();

    const restrictionPanelState = this.get('toolbar').get('restrictionPanelState');
    restrictionPanelState.set({sequence: this.get('sequence')});
    restrictionPanelState.registerListeners();
    this.updateColoredEnzymes();
    this.listenTo(this.buffers(), 'change:digest', () => {
      this.updateVirtualDigest();
    });
  }

  _setupPrimerPanel(): void {
    this.get('toolbar').get('primerPanelState').set('buffers', this.buffers());

    const primers = this.get('sequence').sequencePrimers();
    const primerPanelState = this.get('toolbar').get('primerPanelState');
    this.listenTo(
      primers,
      'change:selected',
      (primer: SequencePrimer | null, selected: Array<SequencePrimer>) => {
        selected = primers.where({selected: true});
        primer = selected.length === 1 ? selected[0] : null;
        primerPanelState.set('activePrimer', primer);
      }
    );
  }

  _setupInformationPanel(): void {
    this.get('toolbar').get('informationPanelState').set('buffers', this.buffers());
  }

  _setupAlignmentPanel(): void {
    this.get('toolbar').get('alignmentPanelState').set('buffers', this.buffers());
  }

  _setupGenomeEngineeringPanel(): void {
    this.get('toolbar').get('genomeEngineeringPanelState').set({buffers: this.buffers()});
  }

  _PANEL_SETUP_FNS(): {[k in SequenceToolbarPanelName]: () => void} {
    return {
      featurePanel: this._setupFeaturePanel.bind(this),
      restrictionPanel: this._setupRestrictionPanel.bind(this),
      primerPanel: this._setupPrimerPanel.bind(this),
      informationPanel: this._setupInformationPanel.bind(this),
      historyPanel: () => {},
      alignmentPanel: this._setupAlignmentPanel.bind(this),
      genomeEngineeringPanel: this._setupGenomeEngineeringPanel.bind(this),
    } as const;
  }

  _registerTopologyListener(): void {
    const sequence = this.get('sequence');
    this.listenTo(sequence.get('_sequence'), 'change:circular', (model: Backbone.Model, value: boolean) => {
      const targetBufferTabs = this.get('topologyMap')!.collection;

      if (this.get('topologyMap') instanceof CircularMapTabState) {
        // if we have a circular map, but we do not need it anymore...
        if (!this.get('sequence').circular()) {
          targetBufferTabs.remove(this.get('topologyMap'));
          this.set('topologyMap', this.get('miniMap'));
        }
      } else {
        // if we don't have a circular map, but we need one
        if (this.get('sequence').circular()) {
          const newTab = new CircularMapTabState({sequence});
          targetBufferTabs.add(newTab);
          this.set('topologyMap', newTab);
        }
      }
      const topologyMap: MergedMapStateSignatures = this.get('topologyMap')!;
      topologyMap.set({active: true});
    });
  }

  setupTabs(assemblyHistoryData?: AssemblyHistoryQuery | null): void {
    this._setupPrimaryBufferTab();
    this._setupSecondaryBufferTabs(assemblyHistoryData);
  }

  handleSplitWorkspaceChange(): void {
    const sequence = this.model();
    const selection = sequence.selection();
    sequence.trigger('jump', selection.start(), selection.end());
    sequence.trigger('splitWorkspace');
  }

  open(param?: {open?: boolean}): JQueryPromise<FileState> {
    if (param == null) {
      param = {};
    }
    let {open} = param;
    if (open == null) {
      open = true;
    }
    if (open && this.get('sequence').get('_sequence').parts().length) {
      // Sequence may have changed, so we should refetch.
      // We do it afterwards, because usually the sequence
      // probably hasn't changed. And, it will let them
      // see the change being reflected when they open it.
      this.get('sequence')
        .fetch()
        .then(() => {
          // If one of the parts gets shorter, the selection could be invalid.
          this.get('sequence').selection().clampToSequence();
        });
    }
    return super.open(...arguments);
  }

  updateColoredEnzymes(): void {
    if (this.get('sequence').isOligo() || this.get('sequence').isRNASequence()) {
      return;
    }
    const restrictionPanelState = this.get('toolbar').get('restrictionPanelState');
    restrictionPanelState.updateActiveEnzymes();
    restrictionPanelState.updateHighlightCompatible();
    const activeEnzymes = this.get('sequence')
      .get('enzymes')
      .filter((e: Enzyme) => e.get('active'));
    restrictionPanelState.get('selectedEnzymes').reset(activeEnzymes);
  }

  updateVirtualDigest(): void {
    const allDigests = Digests.get();

    const digests = this.buffers()
      .chain()
      .map((buffer: BufferState) => buffer.tabs().models)
      .flatten()
      .filter(
        (tabState: TabState) =>
          __guardMethod__(tabState.get('analysis'), 'get', (o) => o.get('analysis_type')) ===
          SequenceAnalysisConstants.DIGEST
      )
      .value();

    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    allDigests.remove(allDigests.filter((digest: any) => digest.get('sequence').id === this.id));
    allDigests.add(digests);

    let tabState = this.findTab(VirtualDigestTabState);

    if (digests.length === 0 && tabState != null) {
      const buffer = this.buffers().find((buffer) => buffer.tabs().contains(tabState!));
      buffer.tabs().remove(tabState);
    } else if (tabState == null) {
      tabState = new VirtualDigestTabState({digests: allDigests, sequence: this.get('sequence')});
      const activeBuffers = this.buffers().where({active: true});
      // Typescript and ESLint disagree about whether this assertion is necessary.
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      activeBuffers[activeBuffers.length - 1].tabs().add(tabState!);
    }
  }

  findAlignmentTab(model: AlignmentAnalysis): SequenceAlignmentTabState | null {
    return this.findTab(
      SequenceAlignmentTabState,
      (tab) => tab.get('alignmentId') === model.get('apiId')
    ) as SequenceAlignmentTabState;
  }

  openTranslationTabView(): void {
    let tab = this.buffers().getTabByClass(TranslationTabState);
    if (tab != null) {
      tab.set({active: true});
    } else {
      tab = new TranslationTabState({sequence: this.get('sequence')});
      // Typescript and ESLint disagree about whether this assertion is necessary.
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      this.buffers().addTab(tab!);
    }
  }

  isRegistryItem(): true {
    return true;
  }
}

SequenceFileState.initClass();

// A FileState for a display-only sequence.
// Sequence models with this FileState may be used to render sequence map previews on their own
// without associated buffer tabs and toolbars.
export class DisplaySequenceFileState extends SequenceFileState {
  static Model: typeof sequencelib.Sequence;

  static initClass(): void {
    this.fileType = ModelTypeConstants.SEQUENCE;
    this.Model = sequencelib.Sequence;
    this.prototype.hasNote = false;
  }

  hasBatches(): boolean {
    return false;
  }

  hasResults(): boolean {
    return false;
  }

  hasStorage(): boolean {
    return false;
  }

  hasMetadata(): boolean {
    return false;
  }

  hasChildEntityTabs(): boolean {
    return false;
  }

  hasUnsavedChanges(): boolean {
    return false;
  }

  hasRelevantItemsTab(): boolean {
    return false;
  }

  hasTestOrdersTab(): boolean {
    return false;
  }

  setupTabs(): void {}

  initialize(attributes: FolderItemStateAttributes, options: unknown): void {
    super.initialize(attributes, options);
    const sequence = this.get('sequence');
    // The restriction panel state is shared across all sequences. For display sequences we want to be able
    // to control the visible enzymes without reacting to changes in the global panel state.
    this.get('toolbar').get('restrictionPanelState').stopListening();
    const biojsSequence = sequence.get('_sequence');
    const sequenceAttributes = {
      canOpenSelectionContextMenu: false,
      writable: false,
      permissions: {
        ...biojsSequence.get('permissions'),
        polymerFeaturesEditable: false,
        polymerResiduesEditable: false,
        writable: false,
        appendable: false,
        admin: false,
      },
    };
    biojsSequence.set(sequenceAttributes);
  }
}

DisplaySequenceFileState.initClass();

/* Open folder in Nav V3. */
async function openFolderListing(
  folderId: string,
  queryKey: LegacyFolderURLQueryKey & QueryKey
): Promise<void> {
  LoadingScreen.show();
  const folderURLData = await parseFolderURL(folderId, queryKey);
  const folder = folderURLData.folder;
  if (queryKey.openProjectSettings) {
    const permissionsById = await PermissionDAO.bulkFetchPermissions([folderId]);
    const permissions = permissionsById[folderId];
    assert(folder?.source?.id != null, 'Expected folder to have source id if openProjectSettings queryKey');
    runModal<ProjectSettingsModalProps>(ProjectSettingsModal, {sourceId: folder?.source?.id, permissions});
  } else if (
    queryKey.openManageAccess &&
    folder &&
    folder.parent &&
    BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_FOLDER_PERMISSIONS
  ) {
    PoliceableActions.openSavingCollaborationManagementModal(folderId);
  } else if (queryKey.openManageAccess && folder && folder.parent == null) {
    runModal(SavingCollaborationManagementModal, {
      policeableId: folder.source!.id,
      onRequestSubmit: (collaborations: Array<Collaboration>) =>
        SourceActions.updateSourceCollaborations(folder.source!.id, collaborations).then(() => {}),
    });
  }
  // @ts-expect-error TODO: Folder cannot be null and should be converted to StringIDFolder.
  getStore().dispatch(SidepanelReduxActions.listFolder(folder, folderURLData.searchParams));
  SidepanelActions.expand();
  LoadingScreen.hide();
}

class FileStates extends SingletonCollection<FileState> {
  // @ts-expect-error Warns about value never read
  private static ProxyFileState: typeof ProxyFileState;
  // @ts-expect-error Warns about value never read
  private static _StageEntryFileState: typeof StageEntryFileState;
  private static FOLDER_ITEM_STATES: [
    typeof SequenceFileState,
    typeof EntryFileState,
    typeof ProtocolFileState,
    typeof BasicFolderItemFileState,
    typeof DatasetFileState,
    typeof FileFileState,
    typeof ProteinFileState,
    typeof MixtureFileState,
    typeof ProcessFileState,
    typeof MoleculeFileState,
    typeof StudyFileState,
    typeof WorksheetFileState,
  ];
  private static STORAGE_ITEM_STATES: [
    typeof BoxFileState,
    typeof ContainerFileState,
    typeof GridFileState,
    typeof PlateFileState,
    typeof LocationFileState,
  ];
  private static NON_WORKSPACE_ITEM_STATES: Array<
    | typeof FormDefinitionFileState
    | typeof ProcedureFileState
    | typeof RequestV2DefinitionFileState
    | typeof SubtemplateFileState
    | typeof TemplateFileState
    | typeof AnalysisTemplateFileState
  >;
  private static ITEM_STATES: Array<typeof FileState>;

  public static WORKSPACE_ITEM_TYPES: Array<string>;
  public static WORKSPACE_ITEM_STATES: Array<typeof FileState>;
  // public solely for tests
  public static _SequenceFileState: typeof SequenceFileState;
  public static _ContainerFileState: typeof ContainerFileState;
  public static _PlateFileState: typeof PlateFileState;
  public static _EntryFileState: typeof EntryFileState;
  public static _TemplateFileState: typeof TemplateFileState;
  public static _ProtocolFileState: typeof ProtocolFileState;
  public static _BasicFolderItemFileState: typeof BasicFolderItemFileState;

  openFileXHRs!: {[fileId: string]: JQueryPromise<FileState | undefined>};

  static initClass(): void {
    this.ProxyFileState = ProxyFileState;
    this._TemplateFileState = TemplateFileState;
    this._EntryFileState = EntryFileState;
    this._ProtocolFileState = ProtocolFileState;
    this._SequenceFileState = SequenceFileState;
    this._BasicFolderItemFileState = BasicFolderItemFileState;
    this._StageEntryFileState = StageEntryFileState;
    this._ContainerFileState = ContainerFileState;
    this._PlateFileState = PlateFileState;

    this.FOLDER_ITEM_STATES = [
      SequenceFileState,
      EntryFileState,
      ProtocolFileState,
      BasicFolderItemFileState,
      DatasetFileState,
      FileFileState,
      ProteinFileState,
      MixtureFileState,
      ProcessFileState,
      MoleculeFileState,
      StudyFileState,
      WorksheetFileState,
    ];
    // TODO(T9772): Remove GridFileState from this
    this.STORAGE_ITEM_STATES = [
      BoxFileState,
      ContainerFileState,
      GridFileState,
      PlateFileState,
      LocationFileState,
    ];
    this.WORKSPACE_ITEM_STATES = [
      ...this.FOLDER_ITEM_STATES,
      BenchlingAppFileState,
      AnalyticsDashboardFileState,
      AnalysisFileState,
      BulkAssemblyFileState,
      ConnectionFileState,
      RequestFileState,
      RunFileState,
      StageEntryFileState,
      ProcessTaskFileState,
      JellyfishFileState,
      RequestV2SubmissionFileState,
      ...(getConfig('ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE')
        ? [
            FormDefinitionFileState,
            TemplateFileState,
            SubtemplateFileState,
            ProcedureFileState,
            RequestV2DefinitionFileState,
            AnalysisTemplateFileState,
          ]
        : []),
      ...this.STORAGE_ITEM_STATES,
    ] as Array<typeof FileState>;
    this.WORKSPACE_ITEM_TYPES = this.WORKSPACE_ITEM_STATES.map(
      (fileState) => (fileState as typeof FolderItemState).fileType
    );
    this.NON_WORKSPACE_ITEM_STATES = getConfig('ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE')
      ? []
      : [
          FormDefinitionFileState,
          RequestV2DefinitionFileState,
          ProcedureFileState,
          TemplateFileState,
          SubtemplateFileState,
          AnalysisTemplateFileState,
        ];
    this.ITEM_STATES = this.WORKSPACE_ITEM_STATES.concat(this.NON_WORKSPACE_ITEM_STATES);
  }

  initialize(models?: Array<FileState>, options?: unknown): void {
    this.openFileXHRs = {};
  }

  isWorkspaceItem(fileState: FileState): boolean {
    // @ts-expect-error Hack that doesn't seem worth the effort to get it to typecheck.
    return FileStates.WORKSPACE_ITEM_STATES.includes(fileState.constructor);
  }

  activate(fileState: FileState): void {
    if (!fileState.get('active')) {
      this.each((fileState: FileState) => fileState.set('active', false));
      fileState.beforeActivate();
      fileState.set('active', true);
      fileState.trigger('open', fileState);
    }
    if (!fileState.collection) {
      // In rare cases, the rendering of a tab may cause the workspace item to be removed.
      // We simply abort to avoid an infinite loop where syncTitleAndURL tries to re-open
      // the file.
      return;
    }

    const currentURL = benchlingUtil.getRelativeURL(window.location.href);
    const queryStr = window.location.search ?? '';
    const currentURLWithoutQueryStr = currentURL?.substr(0, -queryStr.length);
    const nextURL = fileState.editURL();

    const replace =
      // /editor redirects forward to the file you have open - without replacing, hitting "back" would
      // redirect back to /editor which immediately redirects forward again, effectively breaking navigation.
      document.location.pathname === '/editor' ||
      // Similarly, query strings in filestates, e.g. "?batch=bat_123&tab=samples", get truncated when
      // calling syncTitleAndURL. Don't leave the location with the query string in the browser history.
      nextURL === currentURLWithoutQueryStr;

    // Set the URL to match the opened file (if activate was called via routing, this will just no-op).
    fileState.syncTitleAndURL(null, {replace});
  }

  getFileState(fileId: string): typeof FileState | undefined {
    const fileType = APIUtil.apiIdToType(fileId);
    const thisFileState = _.findWhere(FileStates.ITEM_STATES, {fileType});
    return thisFileState;
  }

  // TODO(T3619): Generalizing naming since this can open non-folder-items (e.g. templates) as well.
  openFolderItem(
    fileId: string,
    param?: {
      item?: FolderItemStateModel;
      open?: boolean;
      source?: string;
      versionId?: number;
      versionApiId?: string;
      analyticsMetadata?: {[key: string]: string | boolean | null};
      openManageAccess?: boolean;
    }
  ): JQueryPromise<FileState | undefined> {
    if (param == null) {
      param = {};
    }
    let {item, open, source, versionId, openManageAccess} = param;
    const analyticsMetadata: {[key: string]: string | boolean | null} = param.analyticsMetadata ?? {};
    const SidepanelStore = require('nav/sidepanel/SidepanelStore').default;
    if (open == null) {
      open = true;
    }
    if (open && SidepanelStore.getIsExpanded()) {
      SidepanelActions.unexpand({autoOpenFile: false});
      if (EntityStore.currentUser() == null) {
        // We don't want to allow signed-out users to view anything other than the home sidepanel
        SidepanelActions.openSection(NavConstants.SECTIONS.HOME);
      }
    }

    if (openManageAccess && isCollaboratableId(fileId)) {
      PoliceableActions.openSavingCollaborationManagementModal(fileId);
    }

    // If the file is already open, tell the file to open itself up.
    const file = this.get(fileId);
    if (file != null) {
      trackFileUse('switch', fileId, file, source, analyticsMetadata);
      // @ts-expect-error versionId is no longer used as an option by FileState.open.
      return file.open({open, versionId});
    }

    // If it's not open, open the file:
    const fileType = APIUtil.apiIdToType(fileId);
    const thisFileState = this.getFileState(fileId);
    assert(thisFileState != null, `Couldn't find filestate with fileType \`${fileType}\``);

    if (Array.from(FileStates.WORKSPACE_ITEM_STATES).includes(thisFileState)) {
      // NOTE: This call to addToWorkspace is temporary, once all calls to openFolderItem go through
      // FileBrowserActions.openFile, this will be unnecessary. See T1610.
      FileBrowserActions.addToWorkspace(fileId, item);
    }

    // eslint-disable-next-line benchlint/no-in-operator
    if (fileId in this.openFileXHRs) {
      return this.openFileXHRs[fileId];
    }

    const folderItemState = thisFileState as typeof FolderItemState;
    logProfilerTimingEvent(FILE_STATE_LOADING_EVENT, {
      fileId,
      fileType: folderItemState.fileType,
      isFirstLoad: !this.any((model) => model.get('active')),
    });
    // Otherwise, let the corresponding FileState handle opening itself.
    const xhr = folderItemState
      .openFile(fileId, {versionId})
      .fail((response) => {
        const argForRequestAccess = getArgForRequestAccess(response);
        if (argForRequestAccess) {
          if (canRequestAccess(argForRequestAccess)) {
            requestAccess(argForRequestAccess);
          } else {
            notifications.error(FileBrowserConstants.INACCESSIBLE_MESSAGE);
          }
          FileBrowserActions.removeFromWorkspace(fileId);
          // Reset the URL to the currently open file if opening failed.
          if (open) {
            const activeFile = this.findWhere({active: true});
            if (activeFile) {
              activeFile.syncTitleAndURL();
            }
          }
        } else {
          notifications.notifyError(response);
        }
      })
      .then((fileState) => {
        // If the user closes the file from the workspace before the fetch finishes, don't open it.
        // This only applies to files in the workspace.
        if (
          Array.from(FileStates.WORKSPACE_ITEM_STATES).includes(thisFileState) &&
          !FinderUtil.findInWorkspace(fileId, WorkspaceStore.getState().workspaceItems)
        ) {
          if (typeof (fileState as FolderItemState)?.cleanUp === 'function') {
            (fileState as FolderItemState).cleanUp();
          }
          return;
        }

        (fileState as FolderItemState).layoutWorkspace();
        (fileState as FolderItemState).get('buffers').loadLayout(fileType);
        this.add(fileState!);
        if (open) {
          this.activate(fileState!);
        }
        trackFileUse('open', fileId, fileState!, source, analyticsMetadata);
        logProfilerTimingEvent(FILE_STATE_INITIALLY_LOADED_EVENT, {fileId});
        return fileState;
      });

    this.openFileXHRs[fileId] = xhr;
    xhr.always(() => delete this.openFileXHRs[fileId]);
    return xhr;
  }

  // Opens a Location (and creates a new finder, if necessary).
  openLocationExpandedSearch(location: LocationSummary): void {
    LoadingScreen.show();

    // Kick off fetches required for RegistriesSidepanel to make loading faster
    SampleSchemaActions.fetchAllContainerSchemas();
    SampleSchemaActions.fetchAllBoxSchemas();
    SampleSchemaActions.fetchAllLocationSchemas();
    SampleSchemaActions.fetchAllPlateSchemas();

    // Sources are required for RegistriesSidepanel to render locations
    FileBrowserActions.fetchSources()
      .done(() => {
        StorableActions.openLocationExpandedSearch(location);
      })
      .fail((res: Response) => {
        notifications.notifyError(res);
      })
      .always(() => {
        LoadingScreen.hide();
      });
  }

  // Opens a folder (and creates a new finder, if necessary). Adapted from similar code in router
  // queryKey can be used to specify options on how to open the folder, e.g. section or sort order,
  // in the same format as the URL parameters.
  openFolder(folderId: string, baseURL?: string, queryKey?: LegacyFolderURLQueryKey & QueryKey): void {
    // On initial page load, LoadingScreen.init hasn't been called yet so the LoadingScreen doesn't show
    // but because WorkspaceStore already adds the workspace item the finder renders as loading.
    // By URL navigation this code path can be hit after initial page load, so we keep the
    // LoadingScreen show/hide.
    if (queryKey == null) {
      queryKey = {};
    }
    openFolderListing(folderId, queryKey);
  }

  openFolderItems(
    fileIds: Array<string>,
    param?: {
      open?: boolean;
      source?: string;
    }
  ): JQueryPromise<unknown> {
    let promise;
    if (param == null) {
      param = {};
    }
    let {open, source} = param;
    if (open == null) {
      open = true;
    }

    let firstPromise = null;
    for (const id of Array.from(fileIds)) {
      promise = this.openFolderItem(id, {open: open && firstPromise == null, source});
      if (firstPromise == null) {
        firstPromise = promise;
      }
    }
    return firstPromise != null ? firstPromise : $.Deferred().resolve().promise();
  }

  selectFragment(target: sequencelib.Sequence, fragment: biojs.FragmentResult, rightClick?: boolean): void {
    if (rightClick == null) {
      rightClick = false;
    }
    const fileState = target.fileState();
    if (!fileState.get('active') && !rightClick) {
      this.activate(fileState);
      _.defer(() => target.selectFragment(fragment));
    } else {
      target.selectFragment(fragment);
    }
  }

  getOpenSequences(): Array<sequencelib.Sequence> {
    return (() => {
      const result = [];
      for (const fileState of Array.from(this.models)) {
        if (!(fileState instanceof SequenceFileState)) {
          continue;
        }
        result.push(fileState.get('sequence'));
      }
      return result;
    })();
  }

  closeAll(fileStates: Array<FileState>): void {
    _.chain(fileStates)
      .sortBy((fileState) => fileState.get('active'))
      .forEach((fileState) => {
        this.remove(fileState);
        if (typeof (fileState as FolderItemState).cleanUp === 'function') {
          (fileState as FolderItemState).cleanUp();
        }
      });
  }

  /**
   * Ensure that any inactive non-folder-item types are closed, since they should no longer be accessible
   * (i.e. they aren't listed anywhere to re-open) -- this avoids the situation where a user may open a
   * template, then an entry, then close the entry resulting in returning to the template.
   */
  cleanUpInactiveNonWorkspaceItems(): void {
    const fileStatesToRemove = this.filter((fileState: FileState) => {
      if (fileState.get('active')) {
        return false;
      }
      if (fileState instanceof TemplateFileState || fileState instanceof SubtemplateFileState) {
        return !getConfig('ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE');
      }

      return FileStates.NON_WORKSPACE_ITEM_STATES.some(
        (fileStateCls) => fileStateCls && fileState instanceof fileStateCls
      );
    });
    this.remove(fileStatesToRemove);
    fileStatesToRemove.forEach((fileState: FileState) => {
      if (typeof (fileState as FolderItemState).cleanUp === 'function') {
        (fileState as FolderItemState).cleanUp();
      }
    });
  }

  updateSequenceVersions(
    sequenceIds: Array<string>,
    updateVersionsOptions?: {
      // oxlint-disable-next-line @typescript-eslint/no-explicit-any
      callback?: (() => any) | null;
      switchToLast?: boolean;
      showHistoryPanel?: boolean;
    }
  ): Promise<void> {
    // NOTE: This could potentially be > 20 open sequences that need to be updated. An alternate solution is
    // to invalidate the sequence instead so it's lazily fetched when activated. See
    // https://benchling.quip.com/MLbJAuh6X7wM#VeFACAnSod3 for code plan. Optimize if this is worth
    // optimizing.
    const openSequences = sequenceIds.map((sequenceId) => this.get(sequenceId)).filter((obj) => obj);
    return Promise.all(
      openSequences.map((openSequence) => (openSequence as SequenceFileState).model().fetch())
    ).then(() => {
      openSequences.forEach((openSequence) =>
        (openSequence as SequenceFileState).model().updateVersions(updateVersionsOptions)
      );
    });
  }
}

FileStates.initClass();

// Important that we export FileStates before calling the remaining code, so that any dependencies can
// import FileStates.
export default FileStates;

const fileStates = FileStates.get();
FolderDAOCache.listenToFileStates(fileStates);
FileBrowserStore.setFileStates(fileStates);
InventoryFileStore.setFileStates(fileStates);
WorkspaceStore.listenToFileStates(fileStates);

function __guard__<T>(value: T | null | undefined, transform: (val: T) => unknown): unknown {
  return value != null ? transform(value) : undefined;
}

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
function __guardMethod__<T extends {[f: string]: any}>(
  obj: T,
  methodName: string,
  transform: (object: T, method: string) => unknown
): unknown {
  if (obj != null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}
